import React, { useEffect, useState } from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import fonts from "../../styles/fonts"
import colors from "../../styles/colors"
import { ButtonStyleLightGreen } from "../Core/Buttons/Styles"
import PropTypes from "prop-types"
import { isBrowser } from "../../services/browser"
import ArrowDown from "../../resources/img/ui/arrows/dropdown-down-beige.svg"
import { Trans, withTranslation } from "gatsby-plugin-react-i18next"
import ButtonLightGreen from "../Core/Buttons/ButtonLightGreen"
import Loader from "../Core/Loader"
import MeetingPopup from "./MeetingPopup"
import { getIsFrance } from "../../services/locale"
import WhatsappImg from "../../resources/img/whatsapp/whatsapp-green.svg"

const Background = styled.div`
  background: ${colors.white};
  height: inherit;

  @media (min-width: 1100px) {
    margin-left: -95px;
    margin-top: 0;
  }
`

const FormContainer = styled.div`
  padding: 40px 24px 60px;
  max-width: 800px;
  margin: auto;

  @media (min-width: 1100px) {
    padding: 50px 40px 50px 140px;
    max-width: unset;
  }

  @media (min-width: ${breakpoints.xl}) {
    padding: 50px 93px 50px 170px;
    max-width: unset;
  }
`

const HubspotFormBlock = styled.div`
  text-align: center;
  margin: 0 auto;
  height: 100%;
  min-height: ${(props) => (props.submitted ? "0" : "720px")};

  form {
    position: relative;
    gap: 10px 14px;
  }

  fieldset {
    max-width: unset !important;
    margin-bottom: 10px !important;
  }

  .form-columns-0 {
    margin-bottom: 0;
  }

  .form-columns-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }

  h3 {
    ${fonts.openSans};
    font-size: 14px;
    line-height: 1.71;
    text-decoration: underline;
    margin-bottom: 12px;
    text-align: center;
    margin-top: 18px;
  }

  .hs-form-field {
    width: 100% !important;
    label {
      opacity: 0;
      position: absolute;
    }

    .input {
      margin-right: 0 !important;
      width: 100%;
      border: 1px solid ${colors.secondaryBeige};

      input {
        width: 100%;
        padding: 15px 18px;
        border-color: transparent;
        text-align: center;
        outline: none;

        ::placeholder {
          color: ${colors.greyBorders};
          font-style: italic;
        }
      }
    }
  }

  .hs-fieldtype-textarea {
    .input {
      border: 1px solid ${colors.secondaryBeige};
      height: 82px;
    }
    textarea {
      ${fonts.openSans};
      font-size: 13px;
      width: 100% !important;
      height: 100%;
      padding: 15px 18px;
      outline: none;
      border-color: transparent;
      resize: none;
      ::placeholder {
        color: #979797;
        font-style: italic;
      }
    }
  }

  .hs-fieldtype-select {
    .input {
    }
    select {
      ${fonts.openSans};
      font-size: 13px;
      width: inherit;
      height: inherit;
      border: none;
      text-align: center;
      outline: none;
      background-image: url(${ArrowDown});
      background-repeat: no-repeat;
      background-position: calc(100% - 9px);
      background-size: 10px;
      padding: 16px 18px;

      -webkit-appearance: none;
      -moz-appearance: none;
      :-ms-expand {
        display: none;
      }

      &.is-placeholder {
        font-style: italic;
      }
    }
  }

  .hs-button {
    ${ButtonStyleLightGreen}
    font-weight: 700;
    outline: none;
    width: 100%;
    padding: 20px 40px;
    margin-top: 10px;
  }

  .hs_appointment_type,
  .hs_consultation_type {
    .input {
      border: none;
    }

    ul {
      display: grid;
      width: 100%;
      gap: 14px;
    }
    .hs-form-radio {
      display: flex;
      gap: 14px;
      flex-wrap: wrap;
      flex: 1;

      input {
        position: absolute;
        opacity: 0;
      }

      input:checked + span {
        background: ${colors.secondaryBeige};
      }

      label {
        ${fonts.openSans};
        flex: 1;
        position: relative;
        opacity: 1;

        span {
          font-size: 13px;
          font-style: italic;
          border: 1px solid ${colors.secondaryBeige};
          padding: 12px 10px;
          width: 100%;
          height: 100%;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          cursor: pointer;

          &:hover {
            background: ${colors.secondaryBeige};
          }
        }
      }

      label.disabled {
        background-color: lightgrey;
        color: white;
        border-style: inset;
        span {
          background: lightgrey;
          cursor: default;
          border: 1px solid lightgrey;
        }
        span:hover {
          background: lightgrey;
        }
      }
    }
  }

  .hs_appointment_type {
    ul {
      grid-template-columns: 1fr 1fr;
    }
  }

  .hs_consultation_type {
    ul {
      grid-template-columns: 1fr;
    }
  }

  .hs-error-msgs {
    display: flex !important;
    text-align: center;
    margin: auto;
    width: 100%;
    justify-content: center;
    .hs-error-msg {
      ${fonts.openSans};
      color: #db3232;
      font-size: 11px;
      line-height: 1.12;
      position: relative !important;
      opacity: 1 !important;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    min-height: ${(props) => (props.submitted ? "0" : "590px")};

    .hs_appointment_type {
      ul {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .hs_consultation_type {
      ul {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (min-width: ${breakpoints.xxl}) {
    .hs_appointment_type {
      ul {
        grid-template-columns: ${(props) =>
          props.isFr ? "repeat(2, 1fr)" : "repeat(2, 1fr)"};
      }
    }
  }

  @media (min-width: 1100px) {
    margin: 0;
    min-height: 590px;
  }

  .hs-recaptcha {
    display: none;
  }
`

const FormBlockHeadings = styled.div`
  text-align: center;
  margin-bottom: 33px;
`

const FormBlockHeader = styled.h2`
  ${fonts.moretLight};
  font-size: 40px;
  line-height: 1.15;
  margin-bottom: 20px;
  i {
    font-style: italic;
  }
`

const FormBlockSubheader = styled.p`
  ${fonts.openSans};
  font-size: 16px;
  line-height: 1.62;
  i {
    font-style: italic;
  }
`

const Contact = styled.div`
  ${fonts.openSans};
  /* margin-top: 16px; */
  font-size: 14px;
  display: block;
  text-align: center;

  a {
    color: inherit;
  }
`

const CustomFormContainer = styled.div`
  position: relative;

  form {
    display: ${(props) => (props.submitted ? "none" : "block")};
    visibility: ${(props) => (props.submitted ? "hidden" : "visible")};
  }

  @media (min-width: 1100px) {
    form {
      display: block;
    }
  }
`

const Success = styled.div`
  background: ${colors.white};
  a {
    margin-top: 23px;
    width: 100%;
    padding: 20px 40px;
    font-weight: normal;
  }

  @media (min-width: 1100px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    height: 100%;
  }
`

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.white};
  padding: 50px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  @media (min-width: 1100px) {
    width: 100%;
    height: 100%;
  }
`
const Whatsapp = styled.a`
  margin-top: 20px;
  display: flex;
  align-items: center;
  border-radius: 69.5px;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 1px;
  border: 1px solid black;
  border-radius: 20px;
  justify-content: center;
  height: 57.46px;
  gap: 6px;
  box-shadow: 0px 4px 4px 0px #00000040;
  color: ${colors.trueBlack};
  text-decoration: none;

  img {
    padding-top: 19px;
    padding-bottom: 17.46px;
  }

  span {
    ${fonts.ivyStyleLight};
    font-size: 16px;
    line-height: 14px;
    padding: 21.03px 0;
    text-decoration: none;
  }

  &:hover {
    background-color: #25d366;

    color: white;
    border-color: white;
    img {
      filter: brightness(3);
    }
  }
`

function NewBespokeForm({ containerId, setFormLoaded, formLoaded, t }) {
  const [submitted, setSubmitted] = useState(false)
  const [success, setSuccess] = useState(false)
  const [queryStrings, setQueryStrings] = useState("")
  const [popupOpen, setPopupOpen] = useState(false)
  const [type, setType] = useState()
  const [meetingType, setMeetingType] = useState()

  const formInputCheck = () => {
    const appointmentBtns = document.querySelectorAll(
      'input[id^="appointment_type"]'
    )
    const consultationInputs = document.querySelectorAll(
      'input[id^="consultation_type"]'
    )
    const consultationWeddingBandLabel = document.querySelector(
      'label[for^="consultation_type1"]'
    )
    const ConsultationWeddingBandInput = consultationInputs[1]
    const ConsultationERInput = consultationInputs[0]
    // remove checks and make it specific

    appointmentBtns.forEach(function (item) {
      item.addEventListener("click", () => {
        if (item.value !== "London showroom") {
          ConsultationWeddingBandInput.checked = false
          ConsultationWeddingBandInput.disabled = true
          ConsultationWeddingBandInput.readOnly = true
          // for css label styling
          consultationWeddingBandLabel.classList.add("disabled")
        } else {
          ConsultationWeddingBandInput.disabled = false
          ConsultationERInput.checked = true
          consultationWeddingBandLabel.classList.remove("disabled")
        }
      })
    })
  }

  useEffect(() => {
    let initInterval
    let loadTimeout
    if (isBrowser()) {
      if ("hbspt" in window) {
        initializeHubspotForm()
        loadTimeout = setTimeout(() => {
          setFormLoaded(true)
        }, 300)
      } else {
        initInterval = setInterval(() => {
          if ("hbspt" in window) {
            initializeHubspotForm()
            loadTimeout = setTimeout(() => {
              setFormLoaded(true)
            }, 300)
            clearInterval(initInterval)
          }
        }, 300)
      }
    }

    return () => {
      clearInterval(initInterval)
      clearTimeout(loadTimeout)
    }
  }, [])

  const isFrance = getIsFrance()

  const initializeHubspotForm = () => {
    const activeEnv =
      process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "us"

    if (isFrance) {
      window.hbspt.forms.create({
        region: "eu1",
        portalId: "25002110",
        formId: "1514fdd6-59c3-42c7-99d0-05e2d28c5255",
        target: `#${containerId}`,
        onFormReady: () => {
          formInputCheck()
        },
      })
    } else {
      window.hbspt.forms.create({
        region: "eu1",
        portalId: "25002110",
        formId: "f651af39-a4e6-4e23-b4ad-9fbcff102b2c",
        target: `#${containerId}`,
        onFormReady: () => {
          formInputCheck()
        },
      })
    }
  }

  const extractFullName = (fullName) => {
    const names = fullName.split(" ")
    const firstName = names[0] || ""
    const lastName = names.slice(1).join(" ")
    return { firstName, lastName }
  }

  useEffect(() => {
    const handleFormSubmit = (event) => {
      if (
        event.data.type === "hsFormCallback" &&
        event.data.eventName === "onFormSubmitted"
      ) {
        setSubmitted(true)
        window.scrollTo(0, 0)
        const submissionValues = event.data.data.submissionValues

        const { firstName, lastName } = extractFullName(
          submissionValues.full_name
        )
        const {
          email,
          appointment_type: appointmentType,
          phone,
          consultation_type: consultationType,
        } = submissionValues

        const emailQuery = email ? `email=${email}` : ""
        const firstNameQuery = firstName ? `firstname=${firstName}` : ""
        const lastNameQuery = lastName ? `lastname=${lastName}` : ""
        const phoneQuery = phone ? `phone=${phone}` : ""

        const queryParameters = [
          emailQuery,
          firstNameQuery,
          lastNameQuery,
          phoneQuery,
        ].filter(Boolean)

        const additionalInfoQueryString = queryParameters.join("&")

        setQueryStrings(additionalInfoQueryString)
        setType(appointmentType)
        setMeetingType(consultationType)
        setPopupOpen(true)
      }
    }

    window.addEventListener("message", handleFormSubmit)

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("message", handleFormSubmit)
    }
  }, [initializeHubspotForm, setFormLoaded])

  return (
    <Background>
      <FormContainer>
        <FormBlockHeadings>
          <FormBlockHeader
            dangerouslySetInnerHTML={{
              __html: success
                ? t("bespoke.form.heading.success")
                : t("bespoke.form.heading"),
            }}
          />
          <FormBlockSubheader
            dangerouslySetInnerHTML={{
              __html: success
                ? t("bespoke.form.subheading.success")
                : t("bespoke.form.subheading"),
            }}
          />
        </FormBlockHeadings>
        <CustomFormContainer submitted={submitted ? 1 : 0}>
          {success ? (
            <Success>
              {/* <SuccessMessage>
                <Trans i18nKey="bespoke.form.success.message">
                  Thank you for booking! We will email you shortly with
                  additional information. <br /> Please check your spam / junk
                  folder if you haven’t heard from us.
                </Trans>
              </SuccessMessage> */}
              <ButtonLightGreen to="/">
                {t("bespoke.form.success.buttonLabel")}
              </ButtonLightGreen>
            </Success>
          ) : null}
          {(submitted && !success) || !formLoaded ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : null}
          <HubspotFormBlock
            submitted={submitted ? 1 : 0}
            isFr={isFrance ? 1 : 0}
          >
            <div id={containerId}></div>
          </HubspotFormBlock>
        </CustomFormContainer>
        {submitted ? null : (
          <Contact>
            <Whatsapp
              href={`${isFrance ? `https://api.whatsapp.com/send/?phone=%2B33623046861&text&type=phone_number&app_absent=0` : `https://wa.me/+447897789225`}`}
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src={WhatsappImg} alt="Share on Whatsapp" />

              <span>{t("bespoke.form.whatsapp")}</span>
            </Whatsapp>
            {/* <Trans i18nKey="bespoke.form.contact">
              Any questions? Send us a{" "}
              <a
                href={`${isFrance ? `https://api.whatsapp.com/send/?phone=%2B33623046861&text&type=phone_number&app_absent=0` : `https://wa.me/+447897789225`}`}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Whatsapp"
              >
                whatsapp
              </a>{" "}
              or an <a href="mailto:bespoke@kimai.com">email</a> and we will get
              to you shortly
            </Trans> */}
          </Contact>
        )}
      </FormContainer>
      <MeetingPopup
        open={popupOpen}
        queryStrings={queryStrings}
        type={type}
        meetingType={meetingType}
        setPopupOpen={setPopupOpen}
        setSuccess={setSuccess}
        setSubmitted={setSubmitted}
        initializeHubspotForm={initializeHubspotForm}
      />
    </Background>
  )
}

NewBespokeForm.propTypes = {
  containerId: PropTypes.string.isRequired,
  setFormLoaded: PropTypes.func.isRequired,
}

export default withTranslation()(NewBespokeForm)
